
import { Variables } from "../../variables";
import { Component, Vue, Prop } from "vue-property-decorator";
import Human from "@vladmandic/human";
import SpeechSynthesisUtterance from "speech-synthesis";

@Component({})
export default class FaceDetector extends Vue {
  @Prop() readonly start!: boolean;

  private action = "";
  private step1 = false;
  private step2 = false;
  private isPhotoTaken = false;
  private acceptPhoto = false;
  private image = "";
  private isShotPhoto = false;
  private neutral_step = false;
  private smile_step = false;
  private imageFace = "";
  private attemps = 0;
  private tryAgainOption = false;
  private human: any;
  private humanConfig: any;
  private timestamp: any;
  private fps: any;
  private detectionGestures: any;
  private show = true;

  private message = "Coloque su rostro en el círculo";

  private stream: MediaStream | null = null;
  private canvas: HTMLCanvasElement | null = null;
  private video!: HTMLVideoElement;
  private face: any = null;
  private drawTimer: number | null = null;
  private intervalTimer: number | null = null;

  private circleColor = "#FF0000";
  private greenTimer = 0;
  private isInsideCircle = false;
  private isGreen = this.circleColor == "00ff00";
  private gestures = [
    "Mirar hacia arriba",
    "Mirar hacia abajo",
    "Mirar hacia la izquierda",
    "Mirar hacia la derecha",
  ];

  $refs!: {
    recaptcha: HTMLInputElement;
    canvasface: HTMLCanvasElement;
    camera: HTMLVideoElement;
    photoTakenCanvas: HTMLCanvasElement;
  };
  smileInterval: any;
  neutralInterval: any;
  drawInterval: any;

  get pathBase() {
    return `${Variables.ApiBaseUrl}`;
  }

  async mounted() {
    if (this.isWebGLSupported()) {
      console.log("isWebGLSupported OK");
    } else {
      console.log("isWebGLSupported NOK");
    }
    this.loadHuman();
  }
  isWebGLSupported() {
    try {
      const canvas = document.createElement("canvas");
      const gl =
        canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
      return !!gl;
    } catch (e) {
      return false;
    }
  }
  beforeDestroy() {
    clearInterval(this.drawTimer!);
    clearInterval(this.intervalTimer!);
    this.stream?.getTracks()[0].stop();
  }
  loadHuman() {
    if (this.start !== false) {
      this.action = "";
      this.step1 = false;
      this.step2 = false;
      this.isPhotoTaken = false;
      this.acceptPhoto = false;
      this.image = "";
      this.isShotPhoto = false;
      this.neutral_step = false;
      this.smile_step = false;
      this.imageFace = "";
      this.show = true;
      this.tryAgainOption = false;

      const humanConfig = {
        // user configuration for human, used to fine-tune behavior
        cacheSensitivity: 0,
        modelBasePath: "https://cdn.jsdelivr.net/npm/@vladmandic/human/models",
        async: true,
        filter: { enabled: true, equalization: false }, // lets run with histogram equilizer
        debug: false,
        face: {
          enabled: true,
          detector: { rotation: true, return: true, mask: false }, // return tensor is used to get detected face image
          description: { enabled: true }, // default model for face descriptor extraction is faceres
          // mobilefacenet: { enabled: true, modelPath: 'https://vladmandic.github.io/human-models/models/mobilefacenet.json' }, // alternative model
          // insightface: { enabled: true, modelPath: 'https://vladmandic.github.io/insightface/models/insightface-mobilenet-swish.json' }, // alternative model
          iris: { enabled: true }, // needed to determine gaze direction
          emotion: { enabled: false }, // not needed
          //  antispoof: { enabled: true }, // enable optional antispoof module
          // liveness: { enabled: true }, // enable optional liveness module
        },
        body: { enabled: false },
        hand: { enabled: false },
        object: { enabled: false },
        gesture: { enabled: true }, // parses face and iris gestures
      };

      this.human = new Human(humanConfig);
      this.canvas = this.$refs.canvasface;
      this.video = this.$refs.camera;
      this.detectionGestures = ["none"];

      navigator.mediaDevices
        .getUserMedia({
          audio: false,
          video: {
            facingMode: "user",
          },
        })
        .then((stream) => {
          this.stream = stream;
          this.video.srcObject = stream;
          this.show = false;
          this.video.play();

          this.human?.load().then(() => {
            this.startDetection();
          });
        })
        .catch((error) => {
          console.log("Error loadHuman");
          console.log(error);
        });
    } else {
      this.stopCameraStream();
    }
  }
  startDetection() {
    this.drawTimer = setInterval(this.draw.bind(this), 100);
    this.intervalTimer = setInterval(this.checkLiveness.bind(this), 1000);
    /*this.currentGesture =
              this.gestures[Math.floor(Math.random() * this.gestures.length)];*/
    this.action = "Coloque su rostro dentro del círculo";
    this.playAudio(this.action);
  }
  draw() {
    const width = this.video!.videoWidth;
    const height = this.video!.videoHeight;

    this.canvas!.width = width;
    this.canvas!.height = height;

    this.drawOval(this.circleColor);

    this.human!.detect(this.video!).then((result: any) => {
      this.face = result.face[0];

      if (this.face) {
        const x = this.face.box[0];
        const y = this.face.box[1];
        const w = this.face.box[2];
        const h = this.face.box[3];
        const centerX = x + w / 2;
        const centerY = y + h / 2;
        const radius = Math.min(w, h) / 2;
        const videoWidth = this.video!.videoWidth;
        const videoHeight = this.video!.videoHeight;
        const circleCenterX = videoWidth / 2;
        const circleCenterY = videoHeight / 2;
        const distanceToCenter = Math.sqrt(
          (centerX - circleCenterX) ** 2 + (centerY - circleCenterY) ** 2
        );

        if (distanceToCenter <= radius) {
          this.isInsideCircle = true;
        } else {
          this.isInsideCircle = false;
        }

        // check if face is inside circle
        if (this.isInsideCircle) {
          this.greenTimer += 100;
          // check if enough time has passed inside the circle
          if (this.greenTimer >= 2000) {
            this.circleColor = "#00FF00";
            this.isGreen = true;
            let gestures: string[] = Object.values(result.gesture).map(
              (gesture: any) => gesture.gesture
            ); // flatten all gestures
            for (var i = 0; i < gestures.length; i++) {
              this.detectionGestures.push(gestures[i]);
            }
          } else {
            this.action = "Manténgase quieto con el rostro dentro del círculo";
            this.circleColor = "#FF0000";
            this.isGreen = false;

            this.detectionGestures = ["none"];
          }
        } else {
          this.action = "Coloque su rostro dentro del círculo";
          this.greenTimer = 0;
          this.circleColor = "#FF0000";
          this.isGreen = false;
        }
      } else {
        this.message = "No se ha detectado un rostro";
        this.greenTimer = 0;
        this.circleColor = "#FF0000";
        this.action = "Coloque su rostro dentro del círculo";
        this.isGreen = false;
      }
    });
  }
  checkLiveness() {
    if (this.isGreen) {
      this.isGreen = true;
      clearInterval(this.intervalTimer!);
      this.action = "CIERRE Y ABRA LOS OJOS EN LOS PRÓXIMOS 5 SEGUNDOS";
      this.playAudio("CIERRE Y ABRA LOS OJOS EN LOS PRÓXIMOS 5 SEGUNDOS");
      this.step1Validation();
    }
  }

  playAudio(message: string) {
    this.speakMessage(message);
  }

  speakMessage(message: string) {
    try {
      if (window.speechSynthesis && message) {
        const utterance = new SpeechSynthesisUtterance(`${message}`);
        utterance.lang = "es-ES";
        window.speechSynthesis.speak(utterance);
      }
    } catch (e) {
      console.log(e);
    }
  }
  stopSpeaking() {
    if (window.speechSynthesis && window.speechSynthesis.speaking) {
      window.speechSynthesis.cancel();
    }
  }

  async step1Validation() {
    setTimeout(async () => {
      if (this.face) {
        if (!this.isGreen) {
          this.startDetection();
        } else {
          if (
            this.detectionGestures.includes("blink left eye") &&
            this.detectionGestures.includes("blink right eye")
          ) {
            this.smile_step = true;
            this.action = "MIRE HACIA EL CENTRO DE LA IMAGEN";
            this.playAudio("MIRE HACIA EL CENTRO DE LA IMAGEN");
            this.step2Validation();
          } else {
            clearInterval(this.drawTimer!);
            clearInterval(this.intervalTimer!);

            this.action =
              "NO HA CUMPLIDO LA VALIDACIÓN, INTENTE NUEVAMENTE, ASEGÚRESE DE NO TENER MASCARILLA, RECUERDE QUE TAMBIÉN PUEDE INGRESAR CON SU CONTRASEÑA";
            this.neutral_step = false;
            this.smile_step = false;
            this.attemps++;
            this.tryAgainOption = true;
            if (3 - this.attemps == 0) {
              this.action =
                "Ha realizado los 3 intentos de validación disponibles, por favor intente en otro momento";
              this.tryAgainOption = false;
            }
            this.isShotPhoto = true;

            this.stopCameraStream();
          }
        }
      } else {
        this.action =
          "NO HA CUMPLIDO LA VALIDACIÓN, INTENTE NUEVAMENTE, ASEGÚRESE DE NO TENER MASCARILLA, RECUERDE QUE TAMBIÉN PUEDE INGRESAR CON SU CONTRASEÑA";
        this.neutral_step = false;
        this.smile_step = false;
        this.attemps++;
        this.tryAgainOption = true;
        if (3 - this.attemps == 0) {
          this.action =
            "Ha realizado los 3 intentos de validación disponibles, por favor intente en otro momento";
          this.tryAgainOption = false;
        }
        this.isShotPhoto = true;
        clearInterval(this.drawTimer!);
        clearInterval(this.intervalTimer!);
        this.stream?.getTracks()[0].stop();
        this.stopCameraStream();
      }
    }, 5000);
  }

  async step2Validation() {
    let detections = this.human.result;

    setTimeout(async () => {
      if (detections.face.length > 0) {
        if (!this.isGreen) {
          this.startDetection();
        } else {
          if (this.detectionGestures.includes("looking center")) {
            this.neutral_step = true;
          } else {
            this.action =
              "NO HA CUMPLIDO LA VALIDACIÓN, INTENTE NUEVAMENTE, ASEGÚRESE DE NO TENER MASCARILLA, RECUERDE QUE TAMBIÉN PUEDE INGRESAR CON SU CONTRASEÑA";

            this.neutral_step = false;
            this.smile_step = false;
            this.attemps++;
            this.tryAgainOption = true;
            if (3 - this.attemps == 0) {
              this.action =
                "Ha realizado los 3 intentos de validación disponibles, por favor intente en otro momento";
              this.tryAgainOption = false;
            }
            this.isShotPhoto = true;
            clearInterval(this.drawTimer!);
            clearInterval(this.intervalTimer!);
            this.stream?.getTracks()[0].stop();
            this.stopCameraStream();
          }
          if (this.neutral_step && this.smile_step) {
            this.takePhoto();

            this.action = "CAPTURA REALIZADA";
            this.neutral_step = false;
            this.smile_step = false;
            clearInterval(this.drawTimer!);
            clearInterval(this.intervalTimer!);
          }
        }
      } else {
        this.action = "NO SE DETECTA UNA PERSONA";
      }
    }, 4000);
  }

  setGreenOval() {
    this.clearCanvas();
    this.drawOval("#00ff00");
    this.isGreen = true;
  }

  clearCanvas() {
    let canvas = this.$refs.canvasface;
    var ctx: any = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
  }

  drawOval(color: any) {
    let canvas = this.$refs.canvasface;
    var ctx: any = canvas.getContext("2d");
    let width = canvas.width;
    let height = canvas.height;
    ctx.beginPath();
    if (window.screen.width < 768) {
      ctx.ellipse(
        this.video.videoWidth / 2,
        this.video.videoHeight / 2,
        210,
        210,
        0,
        0,
        2 * Math.PI
      );
    } else {
      ctx.ellipse(
        this.video.videoWidth / 2,
        this.video.videoHeight / 2,
        this.video.videoWidth / 4,
        this.video.videoWidth / 4,
        0,
        0,
        2 * Math.PI
      );
    }
    ctx.lineWidth = 3;
    ctx!.setLineDash([5, 3]);
    ctx.strokeStyle = color;
    ctx.stroke();
    ctx.rect(0, 0, width, height);
    ctx.fillStyle = "rgba(220, 220, 220, 0.8)";
    ctx.fill("evenodd");
  }

  takePhoto() {
    this.isPhotoTaken = true;
    const canvas = this.$refs.photoTakenCanvas;
    const ctx: any = canvas.getContext("2d");
    canvas.width = this.$refs.camera.videoWidth;
    canvas.height = this.$refs.camera.videoHeight;
    ctx.drawImage(this.$refs.camera, 0, 0, canvas.width, canvas.height);

    this.imageFace = canvas.toDataURL("image/jpeg");

    ctx.beginPath();
      if (window.screen.width < 768) {
          ctx.ellipse(
              this.video.videoWidth / 2,
              this.video.videoHeight / 2,
              210,
              210,
              0,
              0,
              2 * Math.PI
          );
      } else {
          ctx.ellipse(
              this.video.videoWidth / 2,
              this.video.videoHeight / 2,
              this.video.videoWidth / 4,
              this.video.videoWidth / 4,
              0,
              0,
              2 * Math.PI
          );
      }
    ctx.lineWidth = 3;
    ctx.strokeStyle = "green";
    ctx.stroke();
    ctx.rect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = "rgba(220, 220, 220, 0.8)";
    ctx.fill("evenodd");

    //save capture
    this.image = canvas.toDataURL("image/jpeg");
    //this.acceptPhoto = true;
    this.acceptPhotoTaken();
    this.stopCameraStream();
  }

  stopCameraStream() {
    try {
      const video = document.getElementById("video-face") as HTMLVideoElement;
      if (video) {
        video.pause();
        (video.srcObject as MediaStream)
          ?.getTracks()
          .forEach((stream) => stream.stop());
      }
    } catch (e) {
      console.log(e);
    }
  }

  acceptPhotoTaken() {
    const fileSizeInBytes = this.imageFace.length * 0.75;
    const fileSizeInKB = fileSizeInBytes / 1024;
    const fileSizeInMB = fileSizeInKB / 1024;

    if (fileSizeInMB > 1) {
      const img = new Image();
      img.onload = () => {
        const maxWidth = 1024;
        const maxHeight = 1024;
        let newWidth = img.width;
        let newHeight = img.height;

        if (img.width > maxWidth) {
          newWidth = maxWidth;
          newHeight = (img.height * maxWidth) / img.width;
        }

        if (newHeight > maxHeight) {
          newHeight = maxHeight;
          newWidth = (img.width * maxHeight) / img.height;
        }

        const canvas = document.createElement("canvas");
        const ctx: any = canvas.getContext("2d");
        canvas.width = newWidth;
        canvas.height = newHeight;
        ctx.drawImage(img, 0, 0, newWidth, newHeight);
        const resizedImage = canvas.toDataURL("image/jpeg", 0.8);
        this.imageFace = resizedImage;
        this.$emit("photoTaken", this.isPhotoTaken, this.imageFace);
      };
      img.src = this.imageFace;
    } else {
      this.$emit("photoTaken", this.isPhotoTaken, this.imageFace);
    }

    this.acceptPhoto = false;
  }
}
